<template>
  <div class="box" :class="{'error': $props.error}">
    <input class="btn" :name="search" v-picker="" readonly type="text" autocomplete="off" id="date" @change="change($event)" :value="$attrs.data" :placeholder="placeholder" >
      <svg class="ico">
        <use :xlink:href="icon"></use>
      </svg>
    </input>
  </div>
</template>

<script>
export default {
  props: {
      date: String,
      icon: String,
      placeholder: String,
      error: Boolean,
      search: String,
      track: Function
  },
  directives: {
      'picker': {
          inserted: (el, binding, vnode) => {
              el.pikadayInstance = new Pikaday({
                  theme: "pika--res",
                  field: el,
                  bound: true,
                  keyboardInput: false,
                  format: 'D MM YYYY',
                  firstDay: 0,
                  reposition: false,
                  minDate: new Date(),
                  onSelect: function onSelect(date) {
                      el.value = st.getUserDate(new Date(date));
                  },
              });
            el.parentNode.insertBefore(el.pikadayInstance.el, el.nextSibling);
          },
          unbind: (el) => {
              el.pikadayInstance.destroy();
          }
      }
  },
  methods: {
    change: function(event) {
      this.$emit('track', "date_change");
      this.$emit('update:data', event.target.value);
    }
  }
}
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.box.error input{
  border: 0.063rem solid $col_red;
  color: $col_red;

  &::placeholder {
    color: $col_red;
  }
}

.btn {
  border: 0.125rem solid #9B9B9B;
  overflow: hidden;
  background-color: #FAFAFA;
  position: relative;
  box-sizing: border-box;
  padding: 1rem 0;
  width: 100%;
  text-align: center;
  border-radius: .3rem;
  height: 3.25rem;
  cursor: pointer;
  outline: none;
  font-size: .875rem;
  font-weight: bold;
  text-transform: uppercase;
  box-shadow: none;
  -webkit-appearance: none;
  caret-color: transparent;
  
  &::placeholder {
    color: $col_black;
  }

  &:focus {
    outline: none;
    color: transparent;
    text-shadow: 0 0 0 $col_black;
  }
}

svg {
  left: .938rem;
  width: 1.25rem;
  position: absolute;
  height: 1.25rem;
  top: 50%;
  margin-top: -0.625rem;
  display: none;
}

@media #{$desktop} {

  .btn {
    width: 12rem;
    padding: 1rem 0 1rem 1rem;
  }

  svg {
    display: block;
  }
}

</style>

<style lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.pika {

  &-single {
    display: block;
    color: #333;
    background: $col_white;
    width: 100%;
    position: relative;
    max-width: 20rem;
    box-shadow: 0 0.125rem 0.125rem $col_quartopacity;
    z-index: 1000;

    &.is-hidden {
      display: none;
    }

    @media #{$s-phone} {
      max-width: 21.875rem;
    }
  }

  &--sdw {
    box-shadow: 0 0.125rem 0.125rem $col_quartopacity;
  }

  &-single {

    &:before,
    &:after {
      content: "";
      display: table;
    }

    &:after {
      clear: both
    }
  }

  &-lendar {
    background-color: $col_white;
    box-sizing: border-box;
  }

  &-title {
    position: relative;
    text-align: center;
    background-color: $col_white;
    color: $col_grey;
    height: 3.438rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;

    select {
      cursor: pointer;
      position: absolute;
      z-index: 9998;
      margin: 0;
      left: 0;
      filter: alpha(opacity=0);
      opacity: 0;
    }
  }

  &-label {
    display: inline-block;
    position: relative;
    z-index: 9999;
    overflow: hidden;
    margin: 0;
    padding: 0.313rem 0.188rem;
    line-height: 1.25rem;
    font-size: 1.125rem;
    font-weight: 600;
    color: $col_black;
  }

  &-prev,
  &-next {
    display: block;
    cursor: pointer;
    outline: none;
    border: 0;
    width: 2.813rem;
    height: 3.438rem;
    text-indent: -999rem;
    white-space: nowrap;
    overflow: hidden;
    background-color: transparent;
    background-position: center center;
    background-repeat: no-repeat;
    opacity: .6;
    position: absolute;
    top: 0;

    &:hover {
      opacity: 1;
    }

    &.is-disabled {
      cursor: default;
      opacity: .2;
    }
  }

  &-prev {
    left: 0;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTAgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+QXJyb3c8L3RpdGxlPiAgICA8ZGVzYz5DcmVhdGVkIHdpdGggU2tldGNoLjwvZGVzYz4gICAgPGRlZnM+PC9kZWZzPiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxnIGlkPSJEZXNrdG9wIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjAuMDAwMDAwLCAtMTUyLjAwMDAwMCkiPiAgICAgICAgICAgIDxnIGlkPSJIb21lcGFnZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzAuMDAwMDAwLCA3OC4wMDAwMDApIj4gICAgICAgICAgICAgICAgPGcgaWQ9IkNoZWNrLUluIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgNDkuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iRGF0ZS1waWNrZXIiPiAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJNb250aCI+ICAgICAgICAgICAgICAgICAgICAgICAgICAgIDxnIGlkPSJBcnJvdyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMzYuMDAwMDAwLCAzMy4wMDAwMDApIHNjYWxlKC0xLCAxKSB0cmFuc2xhdGUoLTM2LjAwMDAwMCwgLTMzLjAwMDAwMCkgdHJhbnNsYXRlKDI0LjAwMDAwMCwgMjEuMDAwMDAwKSI+ICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTkiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+PC9yZWN0PiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoLTMtQ29weS0yIiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMiIgcG9pbnRzPSI5IDUgMTYgMTIgOSAxOSI+PC9wb2x5bGluZT4gICAgICAgICAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgICAgIDwvZz4gICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgIDwvZz4gICAgICAgIDwvZz4gICAgPC9nPjwvc3ZnPg==);
  }

  &-next {
    right: 0;
    background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+PHN2ZyB3aWR0aD0iMTBweCIgaGVpZ2h0PSIxNnB4IiB2aWV3Qm94PSIwIDAgMTAgMTYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+UGF0aCAzIENvcHkgMjwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9IkRlc2t0b3AiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0zNjguMDAwMDAwLCAtMTUyLjAwMDAwMCkiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlPSIjMDAwMDAwIj4gICAgICAgICAgICA8ZyBpZD0iSG9tZXBhZ2UiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMwLjAwMDAwMCwgNzguMDAwMDAwKSI+ICAgICAgICAgICAgICAgIDxnIGlkPSJDaGVjay1JbiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIDQ5LjAwMDAwMCkiPiAgICAgICAgICAgICAgICAgICAgPGcgaWQ9IkRhdGUtcGlja2VyIj4gICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iTW9udGgiPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8ZyBpZD0iQXJyb3ciIHRyYW5zZm9ybT0idHJhbnNsYXRlKDMzMC4wMDAwMDAsIDIxLjAwMDAwMCkiPiAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgPHBvbHlsaW5lIGlkPSJQYXRoLTMtQ29weS0yIiBwb2ludHM9IjkgNSAxNiAxMiA5IDE5Ij48L3BvbHlsaW5lPiAgICAgICAgICAgICAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICAgICAgPC9nPiAgICAgICAgICAgICAgICA8L2c+ICAgICAgICAgICAgPC9nPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);
  }

  &-select {
    display: inline-block;
  }

  &-table {
    width: 100%;
    border: 0;
    padding: 0 0.938rem 0.938rem;
    box-sizing: border-box;

    th,
    td {
      width: 14.285714285714286%;
      height: 2.813rem;
      box-sizing: border-box;
    }

    th,
    th abbr {
      text-align: center;
      color: #30353C;
      line-height: 2.813rem;
    }

    th abbr {
      text-transform: uppercase;
      text-decoration: none;
      font-size: 0.813rem;
    }
  }

  &-button {
    cursor: pointer;
    display: block;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
    border: 0;
    margin: 0;
    width: 100%;
    padding: 0;
    font-size: .875rem;
    text-align: center;
    color: #666;
    height: 2.813rem;
    background-color: $col_white;

    .is-today & {
      color: $col_orange;
      font-weight: 600;
    }

    .is-selected & {
      color: $col_white;
      font-weight: 600;
      background: $col_orange;
    }

    .is-highlight & {
      position: relative;

      &:before {
        content: "";
        height: 2.375rem;
        width: 2.375rem;
        border: 0.125rem solid $col_orange;
        border-radius: 100%;
        position: absolute;
        box-sizing: border-box;
        top: 0.2rem;
        left: 0.25rem;
      }
    }

    .is-selected.is-highlight &:before {
      border: 0;
    }

    .is-highlight.is-disabled & {
      background: none;
    }

    .is-disabled &,
    .is-outside-current-month & {
      pointer-events: none;
      cursor: default;
      color: darken($col_xlgrey, 35%);
      background-color: $col_xlgrey;
      opacity: .3;
      border: none;
      border-radius: 0;
    }
  }

  &-week {
    font-size: 0.688rem;
    color: #999;
  }

  .is-inrange &-button {
    background: lighten($col_orange, 10%);
    color: $col_white;
  }

  .is-startrange &-button {
    color: $col_white;
    background: #6CB31D;
    box-shadow: none;
  }

  .is-endrange &-button {
    color: $col_white;
    background: #33aaff;
    box-shadow: none;
  }
}

@media #{$onlydevice} {
  .pika-single {
    position: fixed !important;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%);
  }
}

</style>